import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/clients',
  title: 'Clientes',
  endpoint: '/app/client',
  breadcrumbs: [{ label: '', location: '' }],
}
